'use es6';

import { FREE, ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { ProductToIconMap } from './ProductToIconMap';
export const HighlightedProductsHeaderConfig = {
  [MARKETING]: {
    [FREE]: {
      title: 'pricingPage.freeCard.title'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      icon: ProductToIconMap[MARKETING][STARTER],
      includes: `pricing-pages.products.marketing-hub-starter.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      icon: ProductToIconMap[MARKETING][PROFESSIONAL],
      includes: `pricing-pages.products.marketing-hub-professional.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      icon: ProductToIconMap[MARKETING][ENTERPRISE],
      includes: `pricing-pages.products.marketing-hub-enterprise.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [SALES]: {
    [FREE]: {
      title: 'pricingPage.freeCard.title'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      icon: ProductToIconMap[SALES][STARTER],
      includes: `pricing-pages.products.sales-hub-starter.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      icon: ProductToIconMap[SALES][PROFESSIONAL],
      includes: `pricing-pages.products.sales-hub-professional.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      icon: ProductToIconMap[SALES][ENTERPRISE],
      includes: `pricing-pages.products.sales-hub-enterprise.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [SERVICE]: {
    [FREE]: {
      title: 'pricingPage.freeCard.title'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      icon: ProductToIconMap[SERVICE][STARTER],
      includes: `pricing-pages.products.service-hub-starter.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      icon: ProductToIconMap[SERVICE][PROFESSIONAL],
      includes: `pricing-pages.products.service-hub-professional.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      icon: ProductToIconMap[SERVICE][ENTERPRISE],
      includes: `pricing-pages.products.service-hub-enterprise.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [CMS]: {
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      icon: ProductToIconMap[CMS][STARTER],
      lowerTierPlus: 'pricing-pages.hubTiers.starter.includes'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      icon: ProductToIconMap[CMS][PROFESSIONAL],
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      icon: ProductToIconMap[CMS][ENTERPRISE],
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [OPERATIONS]: {
    [FREE]: {
      title: 'pricingPage.freeCard.title'
    },
    [STARTER]: {
      title: 'pricing-pages.hubTiers.starter.title',
      icon: ProductToIconMap[OPERATIONS][STARTER],
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages.hubTiers.professional.title',
      icon: ProductToIconMap[OPERATIONS][PROFESSIONAL],
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages.hubTiers.enterprise.title',
      icon: ProductToIconMap[OPERATIONS][ENTERPRISE],
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  }
};